export const FB_API_KEY="AIzaSyDUmqqdzI1UBNVdRv9SaOKzQi3ItKFjU1Y";
export const FB_AUTH_DOMAIN="photografinder-39da5.firebaseapp.com";
export const FB_PROJECT_ID="photografinder-39da5";
export const FB_STORAGE_BUCKET="photografinder-39da5.appspot.com";
export const FB_MESSAGING_SENDER_ID="90466065535";
export const FB_APP_ID="1:90466065535:web:a7dc065719cd5316b4b34a";
export const FB_MEASUREMENT_ID="G-854VT5NLLS";